import React, { useRef } from "react";

export default function WelcomePage({ onImageSelected }) {
    const fileInputRef = useRef(null);

    const handleGalleryClick = () => {
        fileInputRef.current?.click();
    };

    const handleCameraClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            return;
        }

        onImageSelected(file);

        // Allows the same image to be selected again later.
        event.target.value = "";
    };

    return (
        <div className="hv-welcome">

            {/* ====================================================
                INTRO
            ==================================================== */}

            <div className="hv-welcome-intro">

                <div className="hv-welcome-icon">
                    ✨
                </div>

                <h2 className="hv-welcome-title">
                    Identify your collectible
                </h2>

                <p className="hv-welcome-description">
                    Take a photo or choose an existing image and
                    HobbliVision will look for a match.
                </p>

            </div>


            {/* ====================================================
                SCAN OPTIONS
            ==================================================== */}

            <div className="hv-choice-grid">

                <button
                    type="button"
                    className="hv-choice-card"
                    onClick={handleCameraClick}
                >
                    <div className="hv-choice-icon">
                        📷
                    </div>

                    <div className="hv-choice-content">
                        <div className="hv-choice-title">
                            Take a Photo
                        </div>

                        <div className="hv-choice-description">
                            Use your camera to scan a collectible.
                        </div>
                    </div>

                    <div className="hv-choice-arrow">
                        →
                    </div>
                </button>


                <button
                    type="button"
                    className="hv-choice-card"
                    onClick={handleGalleryClick}
                >
                    <div className="hv-choice-icon">
                        🖼️
                    </div>

                    <div className="hv-choice-content">
                        <div className="hv-choice-title">
                            Choose an Image
                        </div>

                        <div className="hv-choice-description">
                            Select a photo from your device.
                        </div>
                    </div>

                    <div className="hv-choice-arrow">
                        →
                    </div>
                </button>

            </div>


            {/* ====================================================
                FILE INPUT
            ==================================================== */}

            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                capture="environment"
                className="hv-file-input"
                onChange={handleFileChange}
            />


            {/* ====================================================
                COMING SOON
            ==================================================== */}

            <div className="hv-coming-soon">

                <div className="hv-coming-header">
                    <span className="hv-coming-badge">
                        Coming Soon
                    </span>
                </div>

                <div className="hv-coming-title">
                    HobbliVision is getting smarter
                </div>

                <div className="hv-coming-description">
                    We're working toward a faster, more complete
                    identification experience.
                </div>

                <div className="hv-coming-features">
                    <span>Automatic detection</span>
                    <span>Slab recognition</span>
                    <span>Internet-assisted identification</span>
                    <span>One-tap collection import</span>
                </div>

            </div>

        </div>
    );
}

